export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const SAVE_ATTR = 'SAVE_ATTR'
export const INSERT_PRODUCT = 'INSERT_PRODUCT'
export const DELETE_PRODUCT = 'DELETE_PRODUCT'